import {useTranslation} from '@aboutyou/i18n';
import {FONT_SIZES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {UnderPaymentSlot} from './UnderPaymentSlot';

export const UnderPaymentPrivacyNotificationComponent = () => {
  const {t} = useTranslation();

  return (
    <UnderPaymentSlot>
      <Paragraph
        dangerouslySetInnerHTML={{
          __html: t(
            'Irrespective of consenting to the newsletter, you will receive product recommendations for similar goods by email based on your purchases (<a href="/privacy-policy">see privacy policy</a>) which you can object to at any time free of charge as described above.',
          ),
        }}
      />
    </UnderPaymentSlot>
  );
};

const Paragraph = styled.div`
  font-size: ${FONT_SIZES.px12};
  line-height: 1.5;
  color: var(--secondaryTextColor);

  a {
    font-weight: bold;
    color: var(--secondaryTextColor);
  }
`;
